import React, { Component } from "react";

class ThankYouPage extends Component {
  render() {
    return (
      <div
        className="thank you"
        style={{
          display:
            this.props.appState.currentPage === "thank" ? "block" : "none",
        }}
      >
        <h1 className="flex-container">Thank You!</h1>
        <div className="text-left ml-5">
          <b>Spread the word:</b>
          <ul>
            <li>
              Hey, Thanks a lot for giving us the valuable recordings. We
              promise you we will put those recordings to good use and improve
              research.
            </li>
            <li>
              We would really appreciate if you spread the word about our
              project and ask your friends and relatives to visit our website.
            </li>
            <li>
              Feel free to leave us a feedback{" "}
              <a
                href="https://forms.gle/dgxWzvraDPAGdbgS6"
                target="_blank"
                rel="noopener noreferrer"
              >
                here
              </a>
              .
            </li>
            <li>
              Contact us if you have any questions or are interested to
              collaborate with us by writing to us at{" "}
              <a href="mailto: spirelab.ee@iisc.ac.in">
                spirelab.ee@iisc.ac.in
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default ThankYouPage;
